<!-- eslint-disable vue/no-unused-components -->
<!--
   V 0.3.4 - 2024-07-30
      - 

    V 0.3.3 -  2023-03-22
      - modified the infor box

   V 0.3.2 -  2023-03-13
      - Added <a> made look like button so user could pass through to the Trip Calendar view
      - Added Spinner so that user is given an indication that new data is being
        looked for.

   V 0.3.1 - 2023-03-08
      - The time was not switching off so this need to be
        change and clearInterval() cassed on  beforeDestroy()
      - Neatened the button
      - linted

   V 0.2.1 - 2023-03-08
      - Rewrote
      - Added Icon size, anchor etc,

   V 0.1.0 - 2023-03-01
      - Copied from MapAll.
      - ideas is that this reports back at reannd

      - Modified from Raptor.Web renamed to MapAll from Trip
      - Removed the plot Trip on the form
      - Move api query into page
      - modified

-->
<template>
  <v-card height="100%">
    <!--
     <v-btn id="buttonTop" fab dark color="indigo" :to="`/vehicle-select`">
       <v-icon dark> mdi-arrow-left-circle </v-icon>
     </v-btn>
  -->

    <v-switch @change="onToggleChange"
              class="toggle-button-crumbs"
              id="buttonToggle"
              v-model="breadCrumb"
              label="Crumbs"></v-switch>

    <div id="map_canvas2"></div>

    <v-container class="d-flex justify-center align-center" flow>
      <v-progress-circular v-show="isLoading"
                           indeterminate
                           size="100"
                           width="15"
                           color="primary" />
    </v-container>
  </v-card>
</template>

<script>
import { differenceInHours } from 'date-fns'

export default {
  data: () => ({
    timerId: null,
    //
    savedFirstPosition: false,
    currentPosition: {},
    breadCrumb: false,
    zoom: 15,
    // create an  dictionary using the untiid and time stamp of a position
    dictPos: {}, // { "UNITID|2023-01-01T00:00:00.000Z": "" },
    dictMarker: {}, // { "UNITID|2023-01-01T00:00:00.000Z": "" },
    dictInfoWindow: {}, // { "UNITID|2023-01-01T00:00:00.000Z": "" },

    icons: [],
    //
    isLoading: false,
    map: null,

    //
    //  parameters passed from previous
    //
    tripId: '',
    VehicleReg: '',
    UnitID: '',
    UnitModelId: 0,
    //
    // Icon stuff
    icoSize: new google.maps.Size(48, 48),
    icoAnchor: new google.maps.Point(6, 20),
    icoOrigin: new google.maps.Point(0, 0),

    //
    base64BlueCar:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAAEpElEQVRYhcWXXWhcRRTHfzP35mabJqmtWBCxTXfbkFqTtha3lvpVciM+VEGh0KCIT7YitPigGBCiT0XfFB+aNx/UFAoqKiWQjbaVEl2osfYj/SDttiAiTW2z+dpud+/4kJnb3b13vyDVA4eZe2bO/P9z5tw79wilFAA9PT02IAFHtzaLKznAA7KANzw8nAMQSikD7gARrY4mIBcJ3NMEskBGa3Z4eDgnXNc14E1Aq24j3JsIZIA5IK3brNllRIOvTCTbRhcZuEjceGqb7npArjD0TYlk2+iDsYdY0rIM25FYdiMIiRDhJ6GU57dmTrm5t+fmyczMkkgy6sZTnehjKEy8CEDzigdYcX8D2TuSfF6glKiwH4kQCrA0kfJzm1qWIi2fnMkzabNw1kZpdDzm5yGXncayIwhpIYUFQgR2txABcTcConwEAJpblpquj2kSzfda0tSKbXvkG5cDIAQoBZ6nEELgeTmktDWopb1MGy6GoDmyQsxApgs8PE+ivBxCCBQCgcCyJFIKlHIQQpHPgbQkXj6HtOwikGAUFo5KqeCLFbA4jqNHiofMwiYCskFg25DPO1VBTLRKIhBOoKGh3Bkau8Pf129x7vwVHulYw7kL19jxZFcRSFgEitvgiC+WJSvq9RtTnLtwjXf2PsfZI2/iPrMJy5JM/jNd1JbTqgRsS5TV65O3ODN+lbde287H77psenGAxLHfsS3BmfGrdD+xijPjVyuuEcArNTTYFn/+dQOA305fCTjs3tnFZ/07EbE+3zb04xgA772xjb6PvvOfS+WxzjXVCRz75SLpdJrdO7toX93F4Ce9oYupiQMBW97zQu0AvfsHOXI8VZ1AOp3mg/0u/fu6QxeqJJYs/xHqiK3k0A9/BOyhHgZ84KtRRKwPEetjYPDXmokMDP4a8Ovf1w3527URMIsgJGrigB/WWkiYOaV+s/NZsBoD88ve+Xvf/xY1cYAPPx0B5dG/vwcR62NP79aKBEL9Vr/Nnt6tCC+LqoVA1D1YbCj4sBRmf1UxfnaEqHsQJZ3AlACB9nVRv7/j1c/56YvX/T63b9L+6JaKmBcvXQ71a7CjtK+LcnFysjKBRmfhZlsbfZijoxeKdrx2fZc/Xk7q9QsQiOiJEWcpj2/uqAgWJvX6hURgsf9F6yQQifw/BPyLeknjf0bAMwRyBcqdTIbW+5rvCWL61ozp+pg2d8ulDMDs1DQRx2LZ8pZFBZ+6Oc3s1LR5zGhMzy4An3PjqW2JEUILk+7n46xbv6omsEvj1xgZSoaO6cJkjoK6wNMPaT2hk+LSTAIkhjhh25KODW0Vwc+fTTEylMSNp7Zrk8mv0tIsA3i1FKf+P3wi2XbyhZe2syHkxwLg7OkrfP/NCdx4agvFuVW+OK1Snpu2sHwbe3nXU3RujBaBnz51ma8P/4wbT20uDHEJgfDyvJJoYhGgWWtTItl2atfup9m4OQbAqbEJDh86jhtPbdTgM1ozBqicVCVQhkRzItk21vvKswAMfnnU7HyGOsBrJhBColWTOAmYM59hIblqBq+LQAmJJq3mgs+yEPq5esDrJlBAwiSleVXNK5atBxzgX7z1BCrTcveDAAAAAElFTkSuQmCC',
    redCar2:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAAEa0lEQVRYhcWXTWsUSRjHf1Xd6fQMMe4OJARnkUjWaDBhWRYRCbl1wIsHwUP8BNGj8wUmfoE5CvMJvAgKXoTMySR4CCKLiuyY2dWFLDETNzLOxt5Jp2sPU9XOS88bRPeBh+qurqr/r556enoeoZQCYHFx0QYk4OjW5ngtAEKgBoSrq6sBgFBKGXEHcLU7GkAek3ioAWqAr722uroaCM/zjHgSGNWty9eJgA8cABXd1swuXS0+nikUnh6zcJPlPO+yvgyBQHieN6LFU5lC4cVEKsXo8DDSshiWEglIIWIXC3X+hEpFYzqN/Xx4yEGtxtu9PXKeNwf8DVQaE88FSCWTWCM2ViCQIQjiF0RPVCgsfd9tbMKyQEYpZfJM2tTP2jiB42AFkkoQ4FoWFmBJiYjZXWsEVJcIACTsKK0iTdMToY26LkdS8X04BIASIBQoBUIIgjDElpJQKSwtZtHdDKABbtRsy/RACCSSQ0KEqAdVyHqrBNiWhUIRhgopZROQEWmNgjkqGXNEbQBDjhO7K7OwEUQpQksxFNrR+Ho+tIt0iEA8ABqg1cwZ2UB1b4+dUomJqSnKpRJnLl3qGYHGNu5ZA5Ld1av7+5RLJaZu32Zya4sz8/Ng2xx8/NjUdvReAMKyOvo/Hz5QLhZJ37rFWC7Hu5kZ/tjYQFgW5WKR4cVFysVi1zXa9tvW4zhUd3YA2H35su1xammJU3fvstkQ5t+fPAHgRDYLKyvRfauNz872BthbX6fi+6SWlkjNzjJ1717sYhdjEkodHcX2A5Ru3MB/+LA3QMX3ObWyQjqbBSAMD5FyKHbRVosLsTH3/Hn+8v22/tjPrRF/n8/zzHLYFILdfL4vCIDdfJ5NIZrmpbNZjmLGdvze7+bzCOqhNmHtB8KMaZ13+Gk/9hez4zf/3c2bXFSK7Tt3UMAP2SybQjC+vNwVIG7eUyG4vLxM2C/A+/HxpnsB+P/uAzRlfy8z82y9Zly42wBOp9PR9duFBSbX1qJrH5hueB5nf25vx87DcTidTrO3vd0dQAwPAzCRTrOzvk65YceT6XT0vJMNOq8dwHUBcF2XyZMnu4rF2aDzOkbgW1l7EiaT/wtA9IaIROJbaYcGIGhw/CAgceLEV1H8/OmTuYw0bb6USz7Age8jEgkSo6PHK16pcPDlW+BrzVB4nucAI8B3dClMflxYYGxqqi+xcqnElv4daDVdmOwCH4GqiYBPvVwyRUNjaSYBMoXChhgaYuzs2e7ib96wtbZGzvPmdZfJr9bSzAfCforT6D98plB4Nn3lCmMzM/Hir19TfPyYnOf9QnNudS5Oe5TnpjVwyUyh8Hz66lXGLlxoFn/1iuKjR+Q872e9S3POjQDx5Xk302Au9TwZ0RC/Tl+7xvjcHAC7L15QfPCAnOf9pMWr2n0j1Ml6AnSAGMkUCs/PXb8OwG/375udVxlAvG+AGIhRDfEMMGdepZ5cfYsPBNACkdRuqpga9dAfDCI+MEADhElK86qaV6w2iDjAf7Y/+9Q4JR3XAAAAAElFTkSuQmCC',
    amberCar3:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAAEd0lEQVRYhb2Xz28bRRTHPzNeb1wnNU0sRVXaRg60pKAWEvpDqjgg0AZLIHGGWy+oiD/Bl8LFgj+AQxCHiAucOSBZtlohgSoFSouKClUFNm5qoapuwhI7jmPvcNgZxz/Wji2SPulp1rMz8/3Mm7e7fkIpBcDS0pIFSMDWrcX+WgPwgDrgZbPZBoBQShlxG4hotzWA3CdxTwPUgZr2ejabbQjHcYx4FIjpNsLBRKAGVAFXt3Wzy4gWn04nczf2WbjDUhnnkr70gIZwHGdCi0+lk7k7R49FiMUkQkrGbIGUIKUIXMzzVKs1Y/qNrW01qVY9Cn9ukco4Z4EngNueeBGAqakxhC2xpH9DiOAFAWQIlFKEdKYMGhuJWiCawBbs5pm08M/aODuexZgncKtNImFJKAShkESI3t11R0Cp/hFoQfjW0jQ9rWw/fHiMplIcscMAKEAASgFC0Gh4WJb0RUOiFYlBZgANcLtmT6Y3miGkhJ2GQgi0C4TwYaywhVIKT4EUgkZDYVmiQ6Q7CuaoDHC79QBYYX/ndteuPE8h5G4EJIqmAiu8G4V+In0iEAyAtHu6AKQ+JMuGiuvy6EGJ6RMzlEslZk+fbh1JYARkZ9txr6dHWAO94m5SLpWYufAhsTcfMvvCGRAWW5uVjrav/x+Aivsv5dIa8TPvE33pM9xsguJvv4KwKJfWEPG3KZfWRgIIPILKRhmA8tofPbfH594ldv5z8iu7YS7eve1PPfkJfP9p63e3xY8/tzfARnEV1/WFxucuMP3aV4GLzV3uTSilmoH9AI++e4+d8td7A7guHFn4iMmFqwB43g5ShgMX7TYh+r8Qws+cZiPf2x/4uTXi//y+zF9f2uRXBO695aEgANx7y+RXRMe8yYWrNJtDAphFhPBDbcI6DIQZ0z1vZ3udUECA+n7zyzc+YO6yYv32xygFU4tXya8IYvNXBgIEzbv/heDU/BU8b0iA5vXOMxcCatvrAB3Zv5eZeZblrxn0IuoBmE1E9VWDjWsXmXxjFYCNaxepbcPz89HuKR1WLFQD5yFsZhM2jx9XBwMgIwAcPWbxd/FH1tt2nHg2pr/g/W3veUMC2Idg9uTEQLEgG3VeX4CnZb0AocFnfFAAuw/I0wPwDECjzaltKSLj4weiWKtUzGVL02K3XKoBVCt1CB0iMj56Ag4W3/TX1j+1pme1iVdTGedSmuDCJHH2IlMzs0OJPSkVKdxZDbynC5OqgTARqOGXS6ZoaC/NJECa3A/IMPGZuYHi5VKewp1VUhnnVd1l8qu7NKsB3jDFaes/fDqZu5lYfJ34sVPB4g/vU7h1nVTGOUdnbvUvTvcoz01r4KLpZO5W4pUk8ePzneJr9yj8nCGVcRbbQ9wFEFyeDzINFgEmtEfTydwviXNvET/xoi/+4C6Fm9+Syjgva/FN7TUj1M/2BOgDMZFO5m4lzr8DQOGnb8zONxlBfGiAAIiYhrgJmDPfxE+uocVHAuiCiGo3VUwdP/TVUcRHBmiDMElpHlXziNVHEQf4D/5EC8f6uRIFAAAAAElFTkSuQmCC',
    home:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADPUlEQVRYhe2Xz0sbQRTHP7MmcU03Qqw0gVK0lCItlqaokNLeGmsxF6GXnmoPxZP/RAtWkEIv1oNeBC/9H3JR0OillELQQw8lh4KFVmNqbUjiTg/OxDXNr40JpdAHj0l2dufznTdvducJKSUAo6OjHsAAfKr10ForAjaQB+xEIlEEEFJKDfcBpnKfEmC0CG4rAXkgpzyfSCSKIhaLabgf6FatSXsikAOOgKxq83qWpoJfklJuthh8xoQQd9VPGyg6Q++XUm5O7+5yNZfjcqHQUvAXr5fPpsl8OLwphLiFWgZn4plAW+BA+Zg6zwyd7drbAq8gosTUWd6qbHdjxt8C/6miWeuamsJ68+ZcApre64HFRTrHxk4GuXGDzKNHTY3jOgLCsghubdE5Nsbhy5ccPH1Kx8AAF7e3MUIhetNpetPphsdzFQHfw4cE3r4Fw2A/Huc4lQJgLxIhuLFBcGvL3WxwEQFrbo7upSVkJsP3mzfxDg2VZtsZj7M3OMjxzg4Av5aXGxZQNwLCsrgwM4M5MUF+dZXs5CSBhQU64/FTcbOzdFy7RmZ8nAsvXtD17BnekREy4+PnE+CNRrFev6bjyhV+zs5SSCYJrq3R0d//x71dz5/jiUQ4ePyYwvo6gcVFelIpMg8eYH/9WpVRcwk8kQhGKMR+PI7MZuleWakILwkeHiaYTJJPJNiPRgGwXr2qhUDEYrEeoBfokVJuvvv0ydErQB1Y3GQ2wLe+vorXn1y/rr+Ie8C32kmo4O20pl9E5TN0GyFt//a34L+AVljDSVhtWzXaX810BOymnj6f2VpA0eF88XrbRnSMXWIanJZLOYDPptkWEfpYriynmLbHAT8SQtydD4crFibTu7vc//GjIdh6IMB8OFyxT72Gj3DUBbb6k1U33OJsaWYAzIfDG0BdERouhLinLun8Ki/NcoDdSHFaOsNLKd/XioQDPsTZ3KpenNYpz3XrLN8+VBLhgN9xhrhMQOXyvJYpYSZgKfdLKT86RTjgtxX8UHlOg6pZXQFVRFg6EoBz5oe4gDcsoIKIbiXiPaDX/JCT5GoY7kpAmQi/cp/qynMS+iM3cNcCHCJ0UuqtqrdY3g0c4DfU3GO2ksBvsQAAAABJRU5ErkJggg==',
    homeRed:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADSklEQVRYhe2XzWsTQRiHn4n5Mg2BtE2DhlI/kIpoq7aK4kncWtAcFHvzoKVU/wgPKoVSBBUsghI8KPg3eEixgtqKIqJoxYNI/QpVsRpKG9O446Ez7TZN0t00QQRfeJlkZ3ee37zzzs6+QkoJQEdHhxtwAV7Vuqms5QATyAJmMpnMAQgppYZ7Ab9yrxLgqhDcVAKyQEZ5NplM5oRhGBoeAEKq9VOdCGSAaSCt2qyepV/BG6SUoxUGLzIhxF710wRy1tAHpJSjk70TzDb9IrdmtqJgd8qDZ9xHOBEdFUJsQy2DNfH8QFXgQP6YOs9cOtu1VwVeQMQ8U2d5pbLdibn+FnipinKtO9TLQN2lFQkoe69fiVzDCHQC0OzdzNHUobLGcRyBGhHkbmwEI9DJwPc+Tk2cZJOnmSeNL4msamCs6R1jTe9sj+coAgdWH+RiZBAXLrpSccayrwDY93Enydh9hmPO32G2I9BXN8Bgw3V+mj9of7+V7b62+dkeDBxi94cW3sy+BuB2+qZtActGoEYEOVvXR7zmCPdn7nH6SzeX66/SWbOw5ufr+tng2cixVJwz4XMcD51gp7+dY6n4ygTs8u2hv/4CMXcjFycHeJQZ4c7aYZo865bceyLUQ4t3O8cnuhjJPGAwcp3HjS84/Nng6+8vRRkll6DF10pkVZSuVJy0mSbRcKsgXNsOfxtDsQcMzwyx/9PcmXOutr8UAmEYRi1QD9RKKUc/33i70IlAMvfB4iSzAbaMry94fW3PRn0ifge+lYyAhlfTyn4R5c/QaYS0/dtnwX8BlTDbSVhsW9ntL2Y6AmZZT6/MTC0gZ3HcKU/ViJax55kuFsqlDIBn3FcVEfqzXFlGMU23BT4thNgbTkQLHuqTvRPM7JmyBVv9KEg4ES3Yp17D01jqAlP9SasbtrG4NHMBhBPRh8CyIjRcCLFPXdL5lV+aZQDTTnE6/w0vpXxaKhIWeBuLc6t4cbpMea5ba/n2rJAIC3yHNcR5AgqX56VMCfMDQeUBKeVzqwgLvFXBp5RnNKiYLSugiIigjgRgnfkUDuC2BRQQEVIingJ6zaeYSy7bcEcC8kQElHtVV5a50E87gTsWYBGhk1JvVb3Fsk7gAH8AkM9jm4JJfPYAAAAASUVORK5CYII='
  }),

  beforeDestroy () {
    clearInterval(this.timerId)
  },

  mounted () {
    this.UnitID = this.$route.params.UnitID
    this.VehicleReg = this.$route.params.VehicleReg
    this.Driver = this.$route.params.Driver
    this.UnitModelId = this.$route.params.UnitModelId

    // test
    // this.UnitID = "352625690442593";
    // this.UnitID = "352625690439375";
    // this.UnitID = "358480087401743";

    if (this.$debug) {
      console.log(`UnitID:  ${this.UnitID}`)
      console.log(`VehicleReg:  ${this.VehicleReg}`)
      console.log(`UnitModelId:  ${this.UnitModelId}`)
    }

    const myOptions = {
      mapTypeId: google.maps.MapTypeId.ROADMAP
    }

    this.map = new google.maps.Map(
      document.getElementById('map_canvas2'),
      myOptions
    )

    this.icons = [] // new Array();
    this.icons[0] = new google.maps.MarkerImage(
      // baseUrl + "/assets/map/blueCar2.png"
      this.base64BlueCar,
      this.icoSize,
      this.icoOrigin,
      this.icoAnchor
    )
    this.icons[1] = new google.maps.MarkerImage(
      // baseUrl + "/assets/map/redCar2.png"
      this.redCar2,
      this.icoSize,
      this.icoOrigin,
      this.icoAnchor
    )

    this.icons[2] = new google.maps.MarkerImage(
      // baseUrl + "/assets/map/amberCar3.png",
      this.amberCar3,
      this.icoSize,
      this.icoOrigin,
      this.icoAnchor
    )
    //
    this.icons[3] = {}
    this.icons[4] = {}
    this.icons[5] = {}

    this.icons[6] = new google.maps.MarkerImage(
      // baseUrl + "/assets/map/home.png",
      this.homeRed,
      this.icoSize,
      this.icoOrigin,
      this.icoAnchor
    )
    this.icons[7] = new google.maps.MarkerImage(
      // baseUrl + "/assets/map/home-red.png",
      this.home,
      this.icoSize,
      this.icoOrigin,
      this.icoAnchor
    )

    this.fetchData()
    // Call fetchData method every 20 seconds using setInterval

    this.timerId = setInterval(() => {
      this.fetchData()
    }, 7000) // 20000)
  },

  methods: {
    fetchData () {
      this.isLoading = true
      let url = this.$baseUrl
      url += `/api/v2/unit-position/${this.UnitID}`

      if (this.$debug) {
        console.log(url)
      }

      this.$axios
        .get(url)
        .then((response) => {
          this.isLoading = false
          if (this.$debug) {
            console.log(
                `${response.data.Latitude}  ${response.data.Longitude} ${response.data.EventDate} `
            )
            // console.log(response);
          }

          this.plotUnitPos(response.data, 33)
        })
        .catch((e) => {
          this.isLoading = false
          console.log('Error')
          console.log(e)
          // this.errors.push(e);
        })
    }, // end fetchData()

    /**
       *
       * V 0.1.0 - 2023-03-07
       *     =
       *
       */
    onToggleChange () {
      console.log('Toggle button state changed:', this.breadCrumb)

      if (!this.breadCrumb) {
        this.removeAllMarkers()
        this.dictPos = {} // } "e.g. UNITID|2023-01-01T00:00:00.000Z": "" };
        this.dictMarker = {} // e.g.  { "UNITID|2023-01-01T00:00:00.000Z": "" };
        this.dictInfoWindow = {} // e.g. "UNITID|2023-01-01T00:00:00.000Z": "" };
      }
    },

    /**
       *   V 0.1.0 - 2023-03-06
       *     - Created to be able to duisplay Display by unit and
       *
       */
    displayInfoWindowByKey (key) {
      try {
        if (typeof UnitID !== 'undefined') {
          this.closeInfoWindows()

          var infWin = this.dictInfoWindow[key]
          var marker = this.dictMarker[key]
          //
          infWin.open(this.map, marker)
          //
        }
      } catch (e) {
        console.log(e)
      }
    },

    /**
       *  V 0.1.0 - 2023-02-28
       *     - MOdified original as it was failing wiht val of undefined,
       *       the val need to be prefxied with typeof
       *
       * @param {*} val
       * @param {*} type
       */
    // eslint-disable-next-line class-methods-use-this
    checkNull (val, type) {
      //
      switch (type) {
      case 'txt':
        if (typeof val === 'undefined') return ''
        return val
      case 'date':
        if (typeof val === 'undefined') {
          /*  */
          return '1970/01/01 00:00:01'
        }
        return val.toLocaleString()

      case 'dd':
        if (val == null) {
          return 0.0
        }
        return val

      case 'i':
        if (typeof val === 'undefined') return -1
        return val
      default:
        if (typeof val === 'undefined') return null
        return val
      }
    },

    /**
       *   V 0.1.0 - 2022-10-03
       *
       */
    getElapsed (lastUpdate) {
      const lastTime = new Date(lastUpdate)
      const currTime = new Date()
      const elapsed = differenceInHours(currTime, lastTime)
      if (elapsed > this.TIME_AMBER_STATIONARY_HRS) {
        return true // this.TIME_AMBER_STATIONARY_HRS;
      }

      return false
    },

    // close any information that may be open
    removeAllMarkers () {
      for (const key in this.dictMarker) {
        console.log(key)
        // debugger;
        var marker = this.dictMarker[key]

        // debugger;
        try {
          marker.setMap(null)
        } catch (e) {
          // console.log("");
        }
      }
    },

    // close any information that may be open
    closeInfoWindows () {
      for (const key in this.dictInfoWindow) {
        // console.log(key);
        var infWin = this.dictInfoWindow[key]

        try {
          infWin.close()
        } catch (e) {
          console.log(e)
        }
      }
    },

    CheckForAmber (IgnStatus, LastUpdateTime) {
      switch (IgnStatus) {
      // off
      case 0:
        return this.getElapsed(LastUpdateTime)
        // on
      case 1:
        return this.getElapsed(LastUpdateTime)
        //
      default:
        break
      }
      return true
    },

    //
    // Fit bounds to coordinates in the dictPos
    //
    zoomCoOrdinates () {
      try {
        const bounds = new google.maps.LatLngBounds()
        for (const key in this.dictPos) {
          var val = this.dictPos[key]

          var lat = this.checkNull(val.Latitude, 'dd')
          var lon = this.checkNull(val.Longitude, 'dd')

          var pos = new google.maps.LatLng(lat, lon)
          bounds.extend(pos)
        }
        this.map.fitBounds(bounds)
        this.map.setZoom(this.zoom)
      } catch (e) {
        console.log(e)
      }
    },

    /*
       *   V 0.1.1 - 2023-03-07
       *       - Adde debug check to some console commands
       *   V 0.1.0  - 2023-03-06
       *       - Renamed, removed stuff for lat lng = 0.0
       */
    plotUnitPos (unitPos, UnitModelId) {
      // debugger;

      if (typeof this.map.getZoom() !== 'undefined') {
        this.zoom = this.map.getZoom()
      }

      if (this.$debug) {
        console.log(` zoom: ${this.map.getZoom()}`)
        console.log(` zoom: ${this.zoom}`)
      }

      const key = `${unitPos.UnitID}|${unitPos.EventDate}`

      if (key in this.dictPos) {
        if (this.$debug) {
          console.log(`Exists: ${key}`)
        }
        return
      }
      this.dictPos[key] = unitPos

      let lat = 0.0
      let lon = 0.0
      let iconID = 0
      let ignition = -1 // or null
      const violationTitle = ''
      let info = ''
      let infoSpeed = ''
      let infoDate = ''
      let unitID = ''
      let lastUpdateTime = null
      let unitModel2ID = 0

      unitModel2ID = UnitModelId // this.checkNull(unitPos.UnitModel2ID, "i");
      lat = this.checkNull(unitPos.Latitude, 'dd')
      lon = this.checkNull(unitPos.Longitude, 'dd')
      ignition = this.checkNull(unitPos.IgnitionStatus, 'i')
      infoDate = this.checkNull(unitPos.EventDate, 'date')
        .replace('T', '  ')
        .split('.')[0]
      infoSpeed = this.checkNull(unitPos.Speed, 'i')

      lastUpdateTime = this.checkNull(unitPos.LastUpdate)
      unitID = this.checkNull(unitPos.UnitID)

      var driverName = this.Driver
      var vehicleReg = this.VehicleReg

      // href="/calendar-trips-select/${unitID}/${vehicleReg}/${driverName}/${unitModel2ID}"
      /*
  <a   class="infoButton "
        href="/calendar-trips-select/${unitID}/${vehicleReg}/${driverName}/${unitModel2ID}"
        @click.prevent="$router.push('/calendar-trips-select/${unitID}/${vehicleReg}/${driverName}/${unitModel2ID}')
        > &nbsp&nbsp Trips &nbsp&nbsp
  </a>

      */
      info = `
<p>
  Registration: ${this.VehicleReg} <br/>
        Driver: ${this.Driver} <br/>
          Date: ${infoDate} <br/>
         Speed: ${infoSpeed} <br/>
        UnitID: ${unitID} <br/>
</p>
<div>
  <a   class="infoButton"
       href="#/calendar-trips-select/${unitID}/${vehicleReg}/${driverName}/${unitModel2ID}"
        > &nbsp&nbsp Trips &nbsp&nbsp
  </a>


</div>
<p></p>`

      if (lat === 0.0 || lon === 0.0) {
        // ------------------------------------------------------------
        //
        //  Plot all faulty lat and long at Raptors old headquarters
        //
        // ------------------------------------------------------------
        lat = -25.9864
        lon = 28.138
      }

      this.currentPosition = new google.maps.LatLng(lat, lon)

      if (ignition === 0) {
        iconID = 0
        if (this.CheckForAmber(ignition, lastUpdateTime)) {
          iconID = 2
        }
      } else {
        iconID = 1
        if (this.CheckForAmber(ignition, lastUpdateTime)) {
          iconID = 2
        }
      }

      if (unitModel2ID === 35) {
        if (ignition === 3) {
          iconID = 7
        } //
        else {
          iconID = 6 // greenhouse
        }
      }

      var shape = {
        coord: [1, 1, 48, 48],
        type: 'circle'
      }

      let zIndex = 50

      if (iconID > 5) {
        zIndex = 150
      }

      if (!this.breadCrumb) {
        this.removeAllMarkers()
      }

      var currPoint = new google.maps.LatLng(lat, lon)

      const marker = new google.maps.Marker({
        position: currPoint,
        map: this.map,
        // shadow: shadow,
        icon: this.icons[iconID],
        shape,
        title: unitPos.UnitID,
        zIndex,
        markerKey: key
      })

      this.dictMarker[key] = marker

      const objInfWin = new google.maps.InfoWindow({ content: info })

      this.dictInfoWindow[key] = objInfWin

      //
      //  Attach a reference to the closeAll function to
      //  the marker.
      //
      objInfWin.closeAll = this.closeInfoWindows

      var mapHere = this.map

      marker.addListener('click', () => {
        objInfWin.closeAll()
        objInfWin.open(mapHere, marker)
      })

      this.closeInfoWindows()

      objInfWin.open(mapHere, marker)

      this.map.setCenter(this.currentPosition, 2)
      this.zoomCoOrdinates()
    }
  }
}
</script>

<style>
    /**
  *   2023-03-13: Added so that button on google infoMap looked better
  */

    .infoButton {
      background-color: #1976d2;
      display: inline-block;
      text-decoration: none;
      color: #fff !important;
      /* color: inherit; */
      padding: 0.5rem 1rem;
      border-radius: 4px;
      transition: all 0.3s;
    }

      .infoButton:hover {
        background-color: #2196f3;
        /* background-color: #1976d2; */
        color: #fff;
      }

  .toggle-button-crumbs {
    /**
     *   2023-03-08 : Neated
     *  reduced z-index so that it does not appear on the navigation drawer
     */
    z-index: 1 !important;
    top: -7px;
    left: 190px;
    width: 115px;
    height: 40px;
    position: absolute;
    background-color: #ffffff;
    /* border-radius: 1px; */

    border: 1px solid #202730;
    padding: 9px;
    /* color: rgb(240, 147, 147); */
    color: #fff;
    height: 42px;
  }

    #buttonTop {
      /**
     *  reduced z-index so that it does not appear on the navigation drawer
     */
      z-index: 1 !important;
      left: 200px;
      position: absolute;
      top: 5px;
    }

    #map_canvas2 {
      position: absolute;
      left: 0px;
      width: calc(100%);
      height: calc(100%);
    }

    /**
   * Below settings are so that the loading spinnger is positioned in the middle of
     the map
   */
    .d-flex {
      display: flex !important;
      height: 100%;
    }

    .justify-center {
      justify-content: center !important;
    }

    .align-center {
      align-items: center !important;
    }
</style>
